'use client'

import * as Accordion from '@radix-ui/react-accordion'
import React from 'react'

import { editorJsBlocksToHtml } from '../_utils/editorjs-to-html'

import type { IProgramModule } from '../../../../types/module'

export interface IAModulesAccordionProps {
	modules: IProgramModule[]
	selectedModules: IProgramModule[]
	onModulesChange: (modules: IProgramModule[]) => void
	initialExpanded?: boolean
}

export const AModulesAccordion: React.FC<IAModulesAccordionProps> = ({
	modules,
	selectedModules,
	onModulesChange,
	initialExpanded = true
}) => {
	const handleCheckboxChange = (module: IProgramModule, isChecked: boolean) => {
		if (isChecked) {
			onModulesChange([...selectedModules, module])
		} else {
			onModulesChange(selectedModules.filter(m => m.id !== module.id))
		}
	}

	const isModuleSelected = (moduleId: number) => {
		return selectedModules.some(m => m.id === moduleId)
	}

	if (!modules || modules.length === 0) return null

	return (
		<div className='a-modules-accordion'>
			<Accordion.Root
				type='multiple'
				defaultValue={initialExpanded ? ['modules'] : []}
				className='a-modules-accordion__root'
			>
				<Accordion.Item value='modules' className='a-modules-accordion__item'>
					<Accordion.Trigger className='a-modules-accordion__trigger'>
						<span className='a-modules-accordion__trigger-text'>
							Pridajte si voliteľné moduly
						</span>
						<span className='a-modules-accordion__trigger-icon'>
							<span className='a-modules-accordion__trigger-icon-line a-modules-accordion__trigger-icon-line--horizontal'></span>
							<span className='a-modules-accordion__trigger-icon-line a-modules-accordion__trigger-icon-line--vertical'></span>
						</span>
					</Accordion.Trigger>

					<Accordion.Content className='a-modules-accordion__content'>
						<div className='a-modules-accordion__content-inner'>
							<p className='a-modules-accordion__description'>
								Pomocou voliteľných modulov si môžete rozšíriť váš program o ďalšie
								služby za zvýhodnené ceny
							</p>

							<ul className='a-modules-accordion__list'>
								{modules.map(module => {
									const descriptionHtml = editorJsBlocksToHtml(module.description)
									return (
										<li
											className='a-modules-accordion__list-item'
											key={module.id}
										>
											<label className='a-modules-accordion__checkbox-label'>
												<input
													type='checkbox'
													value={module.id}
													className='a-modules-accordion__checkbox'
													checked={isModuleSelected(module.id)}
													onChange={e =>
														handleCheckboxChange(
															module,
															e.target.checked
														)
													}
												/>
												<div className='a-modules-accordion__module-content'>
													<strong className='a-modules-accordion__module-name'>
														{module.name}
													</strong>
													{descriptionHtml && (
														<div
															className='a-modules-accordion__module-description'
															dangerouslySetInnerHTML={{
																__html: descriptionHtml
															}}
														/>
													)}
												</div>
											</label>
											<div className='a-modules-accordion__module-price'>
												{module.price} €
											</div>
										</li>
									)
								})}
							</ul>
						</div>
					</Accordion.Content>
				</Accordion.Item>
			</Accordion.Root>
		</div>
	)
}

AModulesAccordion.displayName = 'AModulesAccordion'
